import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
export const CardText = ({ children, ...props }) => (_jsx(Box, { mb: 2, sx: { whiteSpace: "pre-line", display: "inline-block" }, ...props, children: children }));
//# sourceMappingURL=CardText.js.map